module.exports = __webpack_public_path__ + "img/js.d30c2b9a.png";